export const STAINLESS_FASHION_LABEL = 'Stainless Fashion';

export const DEFAULT_JEWELRY_METALS = [
  'BRASS-CZ-COLOUR STONE (IMITATION)',
  'SILVER-PLAIN',
  'SILVER- CZ-COLOR STONE',
  'SILVER-CVD (LAB GROWN DIA.)',
  'SILVER-NATURAL DIAMOND',
  'GOLD-PLAIN',
  'GOLD-CZ-COLOR STONE',
  'GOLD- CVD(LAB GROWN DIA.)',
  'GOLD-NATURAL DIAMOND',
  'PLATINUM-PLAIN',
  'PLATINUM-CVD (LAB GROWN DIA.)',
  'PLATINUM-NATURAL DIAMOND',
  'PLATINUM-GOLD-PLAIN',
  'PLATINUM-GOLD-STUDDED (LGD/NATURAL)',
  STAINLESS_FASHION_LABEL,
];

const DISPLAY_ACRONYMS = new Set(['CZ', 'CVD', 'LGD']);

const normalizeCatalogToken = (value = '') =>
  String(value || '')
    .trim()
    .replace(/\s+/g, ' ')
    .toUpperCase();

export const isDirectListingJewelryMetal = (value = '') =>
  normalizeCatalogToken(value) === normalizeCatalogToken(STAINLESS_FASHION_LABEL);

export const formatCategoryDisplayName = (value = '') =>
  String(value || '')
    .trim()
    .replace(/[A-Za-z]+/g, (word) => {
      const normalizedWord = word.toUpperCase();

      if (DISPLAY_ACRONYMS.has(normalizedWord)) {
        return normalizedWord;
      }

      return normalizedWord.charAt(0) + normalizedWord.slice(1).toLowerCase();
    });
